'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { type ReactNode } from 'react';
import { MatchingEventBanners as DesignSystemMatchingEventBanners } from 'design-system/client';
import type { MatchingEventBannerData } from './types';
import TrustedHtml from '../TrustedHtml';
import { useLocale } from 'next-intl';
function MatchingEventBanners(t0) {
  const $ = _c(94);
  const {
    matchingEvents,
    children,
    className
  } = t0;
  const t = useTranslations("nextjs");
  const locale = useLocale();
  let t1;
  if ($[0] !== matchingEvents) {
    t1 = matchingEvents.map(_temp);
    $[0] = matchingEvents;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("donate.matching_event.banner_read_conditions");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("donate.matching_event.ww_title.spendenmarathon");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("donate.matching_event.ww_title.verdopplungsaktion");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = {
      spendenmarathon: t3,
      verdopplungsaktion: t4
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("core.close");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("donate.matching_event.event_time.heading");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      heading: t7
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("donate.matching_event.event_budget.heading");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = {
      heading: t9
    };
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("donate.matching_event.matching_conditions.how_it_works");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t("donate.matching_event.matching_conditions.spendenmarathon");
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t("donate.matching_event.matching_conditions.heading");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("donate.matching_event.matching_conditions.bp_spendenmarathon");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t11 || $[30] !== t12 || $[31] !== t13 || $[32] !== t14) {
    t15 = {
      how_it_works: t11,
      spendenmarathon: t12,
      heading: t13,
      bp_spendenmarathon: t14
    };
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("donate.matching_event.further_info.example");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t) {
    t17 = t("donate.matching_event.further_info.spendenmarathon");
    $[36] = t;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t) {
    t18 = t("donate.matching_event.further_info.verdopplungsaktion");
    $[38] = t;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t) {
    t19 = t("donate.matching_event.further_info.ww_default");
    $[40] = t;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t) {
    t20 = t("donate.matching_event.further_info.platform_event_exceptions");
    $[42] = t;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t16 || $[45] !== t17 || $[46] !== t18 || $[47] !== t19 || $[48] !== t20) {
    t21 = {
      example: t16,
      spendenmarathon: t17,
      verdopplungsaktion: t18,
      wwDefault: t19,
      platformEventExceptions: t20
    };
    $[44] = t16;
    $[45] = t17;
    $[46] = t18;
    $[47] = t19;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t) {
    t22 = t("donate.matching_event.sleepy_coins_info.heading");
    $[50] = t;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t) {
    t23 = t("donate.matching_event.sleepy_coins_info.description");
    $[52] = t;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t) {
    t24 = t("donate.matching_event.sleepy_coins_info.learn_more");
    $[54] = t;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t) {
    t25 = t("donate.matching_event.sleepy_coins_info.learn_more_url");
    $[56] = t;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== t22 || $[59] !== t23 || $[60] !== t24 || $[61] !== t25) {
    t26 = {
      heading: t22,
      description: t23,
      learnMore: t24,
      learnMoreUrl: t25
    };
    $[58] = t22;
    $[59] = t23;
    $[60] = t24;
    $[61] = t25;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== t) {
    t27 = t("donate.matching_event.post_code_lottery_info.heading");
    $[63] = t;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== t) {
    t28 = t("donate.matching_event.post_code_lottery_info.description_start");
    $[65] = t;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== t) {
    t29 = t("donate.matching_event.post_code_lottery_info.post_code_lottery");
    $[67] = t;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  let t30;
  if ($[69] !== t) {
    t30 = t("donate.matching_event.post_code_lottery_info.description_end");
    $[69] = t;
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  let t31;
  if ($[71] !== t27 || $[72] !== t28 || $[73] !== t29 || $[74] !== t30) {
    t31 = {
      heading: t27,
      description_start: t28,
      post_code_lottery: t29,
      description_end: t30
    };
    $[71] = t27;
    $[72] = t28;
    $[73] = t29;
    $[74] = t30;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  let t32;
  if ($[76] !== t10 || $[77] !== t15 || $[78] !== t21 || $[79] !== t26 || $[80] !== t31 || $[81] !== t6 || $[82] !== t8) {
    t32 = {
      close: t6,
      duration: t8,
      budget: t10,
      matchingConditions: t15,
      furtherInfo: t21,
      sleepyCoins: t26,
      postCodeLotteryInfo: t31
    };
    $[76] = t10;
    $[77] = t15;
    $[78] = t21;
    $[79] = t26;
    $[80] = t31;
    $[81] = t6;
    $[82] = t8;
    $[83] = t32;
  } else {
    t32 = $[83];
  }
  let t33;
  if ($[84] !== t2 || $[85] !== t32 || $[86] !== t5) {
    t33 = {
      buttonText: t2,
      campaignTypes: t5,
      modal: t32
    };
    $[84] = t2;
    $[85] = t32;
    $[86] = t5;
    $[87] = t33;
  } else {
    t33 = $[87];
  }
  let t34;
  if ($[88] !== children || $[89] !== className || $[90] !== locale || $[91] !== t1 || $[92] !== t33) {
    t34 = <DesignSystemMatchingEventBanners className={className} locale={locale} matchingEvents={t1} text={t33}>{children}</DesignSystemMatchingEventBanners>;
    $[88] = children;
    $[89] = className;
    $[90] = locale;
    $[91] = t1;
    $[92] = t33;
    $[93] = t34;
  } else {
    t34 = $[93];
  }
  return t34;
}
function _temp(t0) {
  const {
    bannerContent,
    title: t1,
    matchingEventId,
    logo,
    backgroundColor,
    color,
    ...event
  } = t0;
  const title = t1 === undefined ? "" : t1;
  return {
    ...event,
    color: backgroundColor,
    title: title ?? "",
    id: matchingEventId,
    logoSrc: logo ?? "",
    logoAlt: title ?? "",
    content: <TrustedHtml as="div" value={bannerContent ?? title ?? ""} />
  };
}
export default MatchingEventBanners;